import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { InputAdornment, TextField } from "@mui/material";

export const FDateInput: React.FC<FBasicPropos> = ({
     field,
    control,
    errors, 
    errorMessage
}) => {
    const { name, editable, icon, inputProps, props} = field;
    if (!errorMessage) errorMessage = errors[name]?.message as string;
    const toLocalDateTimeString = (data: Date) => {
        const date = new Date(data);
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - offset * 60 * 1000);
        return localDate.toISOString().slice(0, 16);
      };
    return (
        <Controller
            name={name}
            control={control}
            // defaultValue={preFilled? preFilled : (defaultValue? defaultValue : undefined)}
            render={({ field: controllerField }) => {
                if (icon) {
                    return (
                        <TextField
                            {...controllerField}
                            label={field.question}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type='datetime-local'
                            error={!!errors[name] || !!errorMessage}
                            helperText={errorMessage}
                            disabled={editable === false}
                            placeholder={field.question}
                            value={toLocalDateTimeString(controllerField.value)}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">
                                    {icon}

                                </InputAdornment>,
                                ... inputProps
                            }}
                            {... (props || {})}
                            // required={field.required}
                        />
                    );
                } else {
                    return (
                        <TextField
                            {...controllerField}
                            label={field.question}
                            variant="outlined"
                            type='datetime-local'
                            margin="normal"
                            fullWidth
                            error={!!errors[name] || !!errorMessage}
                            helperText={errorMessage}
                            disabled={editable === false}
                            inputProps={{ ...inputProps }}
                            value={toLocalDateTimeString(controllerField.value)}
                            {... (props || {})}
                            // required={field.required}
                        />
                    );
                }
            }}
        />
    );
};